export default __webpack_public_path__ + "static/date-label-do-3-dark-c76d299bb9d2d220e9b4bbd3399648182c4524fdb8f253fef1967a6b698ce0f7.png";